export default __webpack_public_path__ + "static/media/share.03a3ac36.svg";